import { render, staticRenderFns } from "./mobileResource.vue?vue&type=template&id=5e5798bf&scoped=true"
import script from "./mobileResource.vue?vue&type=script&lang=js"
export * from "./mobileResource.vue?vue&type=script&lang=js"
import style0 from "./mobileResource.vue?vue&type=style&index=0&id=5e5798bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5798bf",
  null
  
)

export default component.exports